module.exports = __webpack_public_path__ + "img/person-seat-reclined.62f9f4df.svg";